import BasicColor from './color/BasicColor';
import GenericColor from './color/GenericColor';
import BasicSpacing from './spacing/BasicSpacing';
import GenericSpacing from './spacing/GenericSpacing';
import BasicShadow from './shadow/BasicShadow';
import GenericShadow from './shadow/GenericShadow';
import BasicRadius from './radius/BasicRadius';
import GenericRadius from './radius/GenericRadius';
import BasicFontSize from './typography/BasicFontSize';
import BasicFontWeight from './typography/BasicFontWeight';
import GenericFontSize from './typography/GenericFontSize';
import GenericFontWeight from './typography/GenericFontWeight';
import BasicBreakpoint from './breakpoint/BasicBreakpoint';
import GenericBreakpoint from './breakpoint/GenericBreakpoint';

const DesignSystem = {
    Color: {
        BasicColor,
        GenericColor,
    },
    Spacing: {
        BasicSpacing,
        GenericSpacing,
    },
    Shadow: {
        BasicShadow,
        GenericShadow,
    },
    Radius: {
        BasicRadius,
        GenericRadius,
    },
    Typography: {
        BasicFontSize,
        BasicFontWeight,
        GenericFontSize,
        GenericFontWeight,
    },
    Breakpoint: {
        BasicBreakpoint,
        GenericBreakpoint,
    },
};

export default DesignSystem;
